
export abstract class Parent {

}
